import { createSelector } from 'reselect';

const getUiState = (state) => state.ui;

const getByKey = (key) =>
  createSelector(getUiState, (uiState) => uiState?.[key]);
const isMainMenuOpened = getByKey('mainMenuOpened');
const isSecondaryMenuOpened = getByKey('secondaryMenuOpened');
const isCancelOrderModalOpened = getByKey('cancelOrderModalOpened');

const addressModalIsOpened = (state, shipmentKey, stopType) =>
  state.ui.addressModal === `${shipmentKey}-${stopType}`;

const isLoadingAddresses = (state, shipmentKey, stopType) =>
  state.ui.loadingAddresses === `${shipmentKey}-${stopType}`;

const isPaymentDataPendingModalOpened = getByKey(
  'paymentDataPendingModalOpened'
);

const isPaymentDataDeniedModalOpened = getByKey('paymentDataDeniedModalOpened');

const isFaqsModalOpened = getByKey('modalFaqsOpened');

const getFeedback = getByKey('feedback');

const getFeedbackParams = getByKey('feedbackParams');

const getFeedbackSuccess = getByKey('success');

const isScrollOnTop = getByKey('onTopScroll');

const isAddressModalEditMode = getByKey('addressModalEditMode');

const isFinishedPaymentData = getByKey('finishedPaymentData');

const getFormTooltip = (state, key) => {
  const content = getUiState(state).formTooltips[key];
  return content || null;
};
const getCatalogStepName = getByKey('catalogStepName');

export default {
  isMainMenuOpened,
  isSecondaryMenuOpened,
  addressModalIsOpened,
  isLoadingAddresses,
  isCancelOrderModalOpened,
  isPaymentDataPendingModalOpened,
  isPaymentDataDeniedModalOpened,
  getFeedback,
  getFeedbackSuccess,
  getFeedbackParams,
  isScrollOnTop,
  isFaqsModalOpened,
  isAddressModalEditMode,
  getFormTooltip,
  isFinishedPaymentData,
  getCatalogStepName,
};
